import type { PropsWithChildren } from 'react'

import { type DataContextType, Provider } from './dataContext'
type Props<T> = PropsWithChildren<DataContextType<T>>
export const DataProvider = <T,>({ children, ...props }: Props<T>) => (
  <Provider value={props}>{children}</Provider>
)
